import { render, staticRenderFns } from "./planCalculator.vue?vue&type=template&id=8f63ba72&scoped=true"
import script from "./planCalculator.vue?vue&type=script&lang=js"
export * from "./planCalculator.vue?vue&type=script&lang=js"
import style0 from "./planCalculator.vue?vue&type=style&index=0&id=8f63ba72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f63ba72",
  null
  
)

export default component.exports